import styled from 'styled-components';

import { fontFamilySize, px } from '../../../../contrib/ui';

export const GamesAreNotCompleteAlert = styled.div`
  background-color: rgba(255, 150, 2, 1);
  width: 100%;
  padding: ${px(10)};
  border-radius: 3px;

  p {
    width: 100%;
    text-align: center;
    color: white !important;

    ${fontFamilySize('Bold', 16)};
    margin: 0;
    line-height: 1.3;
  }
`;
